import React from 'react'
import { SuccessPopupContainer, SuccessPopupTextDiv, SuccessPopupH4Text, Desc, SuccessPopupButtonsDiv } from './LeadGenForm.styled'
import PrimaryButton from '../../../Buttons/PrimaryButton'
import getTranslation from '../../utils/getTranslation';

function LeadGenSuccessPopup({ selectedLanguage, handlePopupState }) {
  return (
    <SuccessPopupContainer>
      <SuccessPopupTextDiv>
        <SuccessPopupH4Text>{getTranslation(selectedLanguage, "leadGenSuccessFormHeader")}</SuccessPopupH4Text>
        <Desc>{getTranslation(selectedLanguage, "leadGenSuccessFormDesc")}</Desc>
      </SuccessPopupTextDiv>
      <SuccessPopupButtonsDiv>
        <PrimaryButton 
            text={getTranslation(selectedLanguage, "leadGenSuccessFormContinue")} 
            fluid 
            onClick={() => handlePopupState((prev)=>{
                return {
                    ...prev,
                    leadGenSuccessPopup: false
                }
            })} 
        />
      </SuccessPopupButtonsDiv>
    </SuccessPopupContainer>
  )
}

export default LeadGenSuccessPopup